module.exports = __webpack_public_path__ + "media/images/menu/phoenix-44d893b193104cba21535904d0f0e346.jpg";